import fp from 'lodash/fp';
import queryString from 'query-string';
import { routes } from '../../../constants/routes';

export const industries = {
  financialAdviser: 'financial-advice',
  mortgageBroker: 'mortgage-broking',
  default: 'default'
}

export const getIndustryFromIdentifier = (identifier, industriesWithCpdCategorys) => {
  const correctIndustry = fp.flow(
    fp.map('industry'),
    fp.find(
      (industry) => industry.identifier === identifier
    )
  )(industriesWithCpdCategorys)
  return identifier ? (correctIndustry ? identifier : undefined) : industries.financialAdviser
}

export const getIndustryCpdCategoriesByName = (name, industriesWithCpdCategorys) => {
  const correctIndustry = fp.flow(
    fp.find(
      (fullIndustry) => fullIndustry.industry.name === name
    )
  )(industriesWithCpdCategorys)
  return correctIndustry ? correctIndustry.cpdCategorys : [];
}

export const defaultSelectedAoaForIndustry = (identifier, industryAoa, selectedAoa, industriesWithCpdCategorys) => {
  switch (getIndustryFromIdentifier(identifier, industriesWithCpdCategorys)) {
    case industries.financialAdviser:
      return selectedAoa;
    default:
      return industryAoa.map(({ id }) => id);
  }
}

export const getRoleFromIndustry = (roles, industry) => fp.find(role => {
  switch (industry) {
    case industries.financialAdviser:
      return role.name === 'Not Specified';
    default:
      return true
  }
})(roles)

export const getOnboardingProcessFromPath = (path) => path.split('/')[2]

const onboardingProcess = {
  choosePlan: 'choose-plan',
  signUp: 'signup',
  billing: 'billing'
}

const onboardingWorkflow = {
  nodes: [
    {
      name: onboardingProcess.choosePlan
    },
    {
      name: onboardingProcess.signUp
    },
    {
      name: onboardingProcess.billing
    }
  ],
  edges: {
    [industries.financialAdviser]: [
      {
        current: onboardingProcess.choosePlan,
        nextUrl: () => (planId) => {
          return `${routes.onboarding.signup}?${queryString.stringify({ chosenPlan: planId })}`
        }
      },
      {
        current: onboardingProcess.signUp,
        nextUrl: () => () => routes.onboarding.billing
      },
      {
        current: onboardingProcess.billing,
        nextUrl: () => () => routes.onboarding.afsLicence(industries.financialAdviser)
      }
    ],
    [industries.default]: [
      {
        current: onboardingProcess.choosePlan,
        nextUrl: (industryIdentifier) => (planId) => {
          return `${routes.onboarding.signupIndustry(industryIdentifier)}?${queryString.stringify({ chosenPlan: planId })}`
        }
      },
      {
        current: onboardingProcess.signUp,
        nextUrl: (industryIdentifier) => () => routes.onboarding.billingIndustry(industryIdentifier)
      },
      {
        current: onboardingProcess.billing,
        nextUrl: (industryIdentifier) => () => routes.onboarding.cpdRequirementsIndustry(industryIdentifier)
      }
    ]
  }
}

export const getNext = (industry, current) => {
  const edges = fp.getOr(onboardingWorkflow.edges[industries.default])(industry)(onboardingWorkflow.edges)
  const currentEdge = fp.find(
    edge => edge.current === current
  )(edges)
  return currentEdge ? currentEdge.nextUrl(industry) : () => { }
}

export const shouldDisplayEvents = (industryArray) => {
  const mortgageBrokerId = industries.mortgageBroker;
  return !fp.isEmpty(fp.filter(({identifier}) => identifier !== mortgageBrokerId, industryArray));
}


// WEBPACK FOOTER //
// ./src/containers/pages/onboarding/industry.js